import React from "react";
import AllStates from "../AllStates";
import ReactTable from "react-table";
class OrganizationTable extends React.Component {
  render() {
    let organizations = this.props.organizations;
    let customSort = (a, b) => {
      let aNull = a == null || a === "";
      let bNull = b == null || b === "";
      if (aNull && bNull) {
        return 0;
      } else if (bNull) {
        return -1;
      } else if (aNull) {
        return 1;
      }
      return (a < b) ? -1 : ((a > b) ? 1 : 0);
    };
    const columns = [
      { Header: "Name", accessor: "name", minWidth: 150, sortMethod: customSort},
      {
        Header: "Country",
        accessor: "country_id",
        maxWidth: 250,
        sortMethod: customSort,
        Cell: props => (this.props.countries[props.value - 1]) ? this.props.countries[props.value - 1].country_name : null,
        filterMethod: (filter, row) => {
          if (this.props.countries[row[filter.id] - 1] && this.props.countries[row[filter.id] - 1].country_name) {
            return this.props.countries[row[filter.id] - 1].country_name
                .toLowerCase()
                .includes(filter.value.toLowerCase());
          }
          return false;
        }
      },
      {
        Header: "State",
        accessor: "state_id",
        maxWidth: 200,
        sortMethod: customSort,
        Cell: props => (AllStates[props.value - 1]) ? AllStates[props.value - 1].state_name : null,
        filterMethod: (filter, row) => {
          if (AllStates[row[filter.id] - 1] && AllStates[row[filter.id] - 1].state_name) {
            return AllStates[row[filter.id] - 1].state_name
                .toLowerCase()
                .includes(filter.value.toLowerCase());
          }
          return false;
        }
      },
      { Header: "City", accessor: "city", maxWidth: 120, sortMethod: customSort},
      // { Header: "Address", accessor: "street_address" },
      {
        Header: "Website",
        accessor: "website",
        sortMethod: customSort,
        Cell: props => (
          <a href={props.value} style={{ color: "black" }}>
            {props.value}
          </a>
        )
      },
      // {
      //   Header: "Description",
      //   accessor: "discription"
      // },
      // {
      //   Header: "Service",
      //   accessor: "service"
      // },
      { Header: "", accessor: "organization_id", show: false },
      {
        Header: "Contacts",
        sortable: false,
        Cell: props => (
          <div className="col text-center">
            <button className="btn btn-outline-primary btn-sm">
              View Contacts
            </button>{" "}
          </div>
        )
      }
    ];
    let filterCaseInsensitive = (filter, row) => {
      const id = filter.pivotId || filter.id;
      return row[id]
        ? String(row[id])
            .toLowerCase()
            .includes(filter.value.toLowerCase())
        : false;
    };
    columns.forEach(h => (h.headerStyle = { fontWeight: "bold" }));
    return (
      <ReactTable
        className="-highlight -striped"
        data={organizations}
        columns={columns}
        page={this.props.page}
        onPageChange={this.props.changePage}
        filterable
        defaultFilterMethod={filterCaseInsensitive}
        onFilteredChange={filters => {
          console.log(filters);
          localStorage.setItem("org_filters", JSON.stringify(filters));
        }}
        defaultFiltered={
          JSON.parse(localStorage.getItem("org_filters")) || []
        }
        getTdProps={(state, rowInfo, column, instance) => {
          return {
            onClick: (e, handleOriginal) => {
              if (!rowInfo) {
                return;
              }
              if (column.Header === "Contacts") {
                this.props.contactClicked(rowInfo.row.organization_id);
              } else if (!(column.Header === "Website" && rowInfo.row.website)) {
                this.props.clicked(rowInfo.row.organization_id);
              }
            }
          };
        }}
      />
    );
  }
}

export default OrganizationTable;
